module.exports = __webpack_public_path__ + "static/media/Advisory Body Structure (1).9ca0aa95.pdf";